var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_39866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 23.5C4.9 23.5 0 18.6 0 12.5C0 6.8 4.4 2.1 10 1.5V-0.5H11C15.1 -0.5 18.9 1.4 21.4 4.7L22 5.5L20.4 6.7C21.4 8.5 22 10.4 22 12.5C22 18.6 17.1 23.5 11 23.5ZM10 3.6C5.5 4.1 2 7.9 2 12.5C2 17.5 6 21.5 11 21.5C16 21.5 20 17.5 20 12.5C20 10.9 19.6 9.3 18.8 7.9L10 14.5V3.6ZM12 1.5V10.5L19.2 5.1C17.3 3.1 14.7 1.8 12 1.5Z",
    fill: "#06362B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_39866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsSvgrepoCom1);
export default __webpack_public_path__ + "static/media/analytics-svgrepo-com 1.83fe447082f061c9fa3ba9d7aacabd2b.svg";
export { ForwardRef as ReactComponent };